export class Suivi {
    id: string;
    idUtilisateurConnecte: string;
    idAmiSuivi: string;
}
